<template>
  <div
    class="VisualBanner h-32 relative z-100 hidden lg:block overflow-hidden"
    :style="{ 'backgroundColor': bgColor }"
    v-bc-get-box-model="{name: 'heroBanner'}"
  >
    <img 
      :src="bgUrl"
      style="min-height: 127px; max-height: 127px; min-width: 1920px;"
      draggable="false" 
    />
    <aw-dropdown
      v-if="showMenu"
      placement="bottom-end"
      :offset="[0, 6]"
      class="Square__Dots flex items-center justify-center cursor-pointer"
    >
      <template v-slot:btn="{ toggle }">
        <div @click="toggle" class="flex items-center justify-center">
          <aw-icon
            icon="dots"
            class="w-4 h-4  text-black hover:text-bc-blue"
          ></aw-icon>
        </div>
      </template>
      <template v-slot:dropdown="{ opened, dropdown }">
        <div
          v-show="opened"
          :ref="dropdown"
          class="Dropdown Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
        >
          <nav class="p-0">
            <a class="block py-1.5 px-3 text-gray-600" href="" @click.prevent="editCurrentFolder()"
              >{{$t('Change header image')}}</a
            >
          </nav>
        </div>
      </template>
    </aw-dropdown>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import editDocumentOrFolder from '../mixins/actions/EditDocumentOrFolder'

export default {
  data() {
    return {
      bgColor: 'rgb(30, 41, 59)'
    }
  },
  computed: {
    ...mapStores(useBcFolderStore),
    bgUrl() {
      if (this.bcFolderStore.current) {
        if (this.bcFolderStore.current.header__file?.previews['3840x254']) {
          return this.bcFolderStore.current.header__file.previews['3840x254']
        } else {
          for (let index = 0; index < this.bcFolderStore.listParents(this.bcFolderStore.current.id).length; index++) {
            const element = this.bcFolderStore.listParents(this.bcFolderStore.current.id)[index];
            if (element.header__file?.previews['3840x254']) {
              return element.header__file.previews['3840x254']
            }
          }
        }
      }

      return this.$presenter.design.imgAppHeader
    },
    showMenu () {
      return this.$route.matched[0].name !== 'BCHome' && this.bcFolderStore.current?.can_edit
    }
  },
  methods: {
    editCurrentFolder() {
      editDocumentOrFolder(this.bcFolderStore.current, this.$store, this.$formValues)
    }
  },
  watch: {
    bgUrl: {
      handler(val) {
        if (!val) {
          this.bgColor = 'rgb(30, 41, 59)'
          return
        }

        const canvas = document.createElement('canvas')
        const pic = new Image()
        pic.src = val
        pic.onload = () => {
          canvas.width = pic.width
          canvas.height = pic.height
          const ctx = canvas.getContext("2d")
          ctx.drawImage(pic, 0, 0)
          const p = ctx.getImageData(pic.width-1, 0, 1, 1).data
          this.bgColor = 'rgb('+ p[0]+', ' + p[1] + ', ' + p[2] + ')'
        }
      },
      immediate: true,
    }
  }
};
</script>

<style lang="scss" scoped>
.VisualBanner {
  @screen lg {
    .modal__lock & {
      @apply mt-10
    }
  }

  &:hover {
    .Square__Dots {
      @apply opacity-100 scale-100;
    }
  }
}
</style>
